
export const step_names = {
    AG: "Agenda",
    CM: "Coach Meetings",
    ME: "Meeting Notes",
    CF: "Coach Feedback",
    MN: "My Notebook",
    MD: "Meditations",
    MG: "Mindset Goals",
    BG: "Building Confidence",
    EY: "Envisioning Yourself",
    IZ: "Influence Zones",
    RL: "Past Roles Reflection",
    NN: "Networking Preparation",
    PT: "Progress Tracker",
    SS: "Suggested Schedule",
    MT: "My Tasks",
    // GC: "Group Coworking",
    MS: "Mission Statement",
    LS: "Life Wheel",
    AL: "Annual Goals",
    FM: "Financial Management",
    RM: "Relationship Management",
    TN: "Travel & Adventure",
    GT: "Giving & Contribution",
    SR: "Spiritual",
    HW: "Health & Wellness",
    LT: "Location To Live",
    PE: "Peers",
    TH: "Therapist",
    KH: "Stakeholders",
    MA: "Manager",
    MO: "Mentors",
    MB: "My Board Of Directors",
    GW: "Group Coworking",
    GH: "Group Coaching",
    GM: "Group Meditation",
    DB: "Discussion Board",
    AD: "Accountability Triads",
    PC: "Peer Coaching",
    AB: "Annual Goal Buddy",
    RB: "Reading Buddy",
    SE: "Settings",
    SC: "Security",
    MP: "My Plan",
    BL: "Billing",
    IN: "Integrations",
    SF: "Share Feedback",
    PP: "Privacy Policy",
    LG: "Logout",
    ON: "Onboarding",
    AS: "Assessment",
    TR: "Target Roles",
    TI: "Target Industries",
    RR: "Role Research",
    RI: "Industry Research",
    RN: "Research Add New",
    CO: "Contacts Brainstorm",
    ED: "Outreach Drafts",
    NT: "Networking Tracker",
    CP: "Call Prep",
    CN: "Call Notes",
    NF: "Networking Reflections",
    NA: "Networking Add New",
    LO: "Upskilling Tracker",
    EN: "Experiences Add New",
    PS: "Professional Summary",
    RE: "Resume",
    CL: "Cover Letter",
    LK: "Linkedin Profile",
    AT: "Job Search Tracker",
    IR: "Interview Research",
    BP: "Interview Responses",
    JR: "Reflections",
    JS: "JobSearch Add New",
    AE: "Target Roles/Industries",
    CR: "Compare Roles",
    PCE: "Pie Chart Exercise",
    RV: "Resume Vision Exercise",
    KD: "Key Definitions",
    ID: "Identify Gaps",
    CT: "Career Trajectory",
    SO: "Strengths Overview",
    SG: "Skill Gap Analysis",
    JP: "Job Posting Exercise",
    UT: "Upskilling Tracker",
    OT: "Compare Options",
    MC: "My Credentials",
    KL: "Key Links",
    SD: "Soft Skill Development",
    BS: "Boundary Setting",
    UP: "Communication",
    TM: "Time Management",
    PM: "Project Management",
    IF: "Improving Focus",
    IV: "Influence & Visibility",
    VP: "Video Pitch",
    PW: "Portfolio/Website",
    TL: "Thought Leadership",
    AK: "ATS Keywords",
    PI: "Mindset Preparation",
    PN: "Places To Network",
    EV: "Past Events",
    UE: "Upcoming Events",
    FE: "Find Events",
    OD: "Onboarding 30/60/90",
    OC: "Onboarding Checklist",
    PR: "Promotions",
    IM: "Internal Mobility",
    MV: "Performance Reviews",
    JE: "Job Expectations",
    CG: "Annual Goals",
    SU: "Stakeholder Updates",
    TA: "Track Achievements",
    EM: "Roadmap",
    CS: "Customer Personas",
    MR: "Market Research",
    DO: "Define Offerings",
    FN: "Financials",
    MK: "Marketing",
    SL: "Sales",
    PD: "Product Development",
    ET: "Team Management",
    EL: "Legal",
    OP: "Operations",
    JT: "Progress Tracker",
    SN: "Strategy and Direction",
    CA: "Calendar",
    JA: "Suggested Schedule",
    TJ: "Target Job Postings",
    TC: "Target Companies",
    SA: "Staffing Agencies",
    VR: "Visa Resources",
    SP: "Set Priorities",
    QT: "Questions To Ask",
    MW: "Mock Interview",
    CI: "Case Interview",
    TE: "Technical Interview",
    IW: "Interview Follow-Ups",
    ST: "Standing Out",
    OA: "Offer Analysis",
    SH: "Salary Research",
    SK: "Key Links",
    HT: "Helpful Tools",
    EP: "Education Planning",
    MCM: "My Commitment",
    MSC: "My Schedule",
    KLJ: "Key Links",
    WVM: "WOKEN Videos Meditations",
    OVD: "Other Videos",
    WB: "WOKEN Book",
    OTB: "Other Books",
    WKB: "WOKEN Blogs",
    OBL: "Other Blogs",
    WW: "WOKE NWorkshops",
    PDC: "Podcasts",
    TMP: "Templates",
    FAQ: "FAQ",
    WHB: "Whiteboard",
    AMS: "My Schedule",
    MI: "Setup Call with Coach",
    NP: "Next Phase",
    DAS: "Dashboard"
  };